import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { Observable } from 'rxjs/internal/Observable';
import { CommonDropDown } from 'app/core/common/types/dropdown.types';
import { LookupService } from 'app/core/common/services/lookup.service';
import { Subject } from 'rxjs/internal/Subject';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';
import { IInwardStatusChange } from './status-change-inward.types';
import { InwardStatus, InwardStatusData } from 'app/core/common/enums/inward.status';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

@Component({
    selector: 'app-status-change-inward',
    templateUrl: './status-change-inward.component.html',
    styleUrls: ['./status-change-inward.component.scss']
})
export class StatusChangeInwardComponent implements OnInit {

    dialogTitle = `Status Change`;
    statusChangeForm: FormGroup;
    statusChange: IInwardStatusChange;
    alert: any;

    statusChanges$: Observable<IInwardStatusChange[]>;
    users: CommonDropDown[];
    filterUsers: CommonDropDown[];

    public InwardStatusData = InwardStatusData;
    public inwardStatuses = Object.values(InwardStatus);

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    multipleInwards: Inward[] = []

    inward: Inward;

    constructor(private _changeDetectorRef: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data: { inward: Inward, inwards: Inward[] },
        private _formBuilder: FormBuilder,
        private _matDialogRef: MatDialogRef<StatusChangeInwardComponent>,
        private _alertMessage: AlertMessageService,
        private _inwardsService: InwardsService,
        private _matDialog: MatDialog,
        private _lookupService: LookupService
    ) {

        const excludedValues = ['outward']; // Add values you want to exclude

        // Get all enum values
        const allValues = Object.values(InwardStatus);

        // Filter out excluded values
        this.inwardStatuses = allValues.filter(value => !excludedValues.includes(value));

        if (this._data.inwards && this._data.inwards.length > 0) {
            this.multipleInwards = this._data.inwards;

            // this.dialogTitle += `s ${this._data.inwards.map(o => o.jobNumber).join(', ')}`
        }
        // else {
        //     this.inward = this._data.inward;
        this.statusChangeForm = this._formBuilder.group({
            inwardStatus: [this._data.inward ? this.getNextEnumValue(this._data.inward.inwardStatus) : ''],
            assignEmployeeId: [this._data.inward ? this._data.inward.statusHolderId : '', [Validators.required]],
            note: [''],
            // reportId: [this._data.inward.reportId],
            inwardId: [this._data.inward ? this._data.inward.id : ''],
            id: []
        });
        if (this._data.inward) { this.dialogTitle += ` ${this._data.inward.jobNumber}`; }
        else {
            this.dialogTitle += `s ${this._data.inwards.map(o => o.jobNumber).join(', ')}`
        }
        //this.dialogTitle += ` ${this._data.inward.jobNumber}`;
    }
    //}

    ngOnInit(): void {
        this._lookupService.getUsers().subscribe((res) => {
            this.users = res;
            this.filterUsers = res;
        });


        if (this._data.inward && this._data.inward.reportStatusId && this._data.inward.reportStatusId != null) {
            // Request the data from the server
            this._inwardsService.ReportStatusChange(this.statusChange)
                .subscribe((res) => {
                    if (res.isSuccess) {
                        this.statusChange = res.result;
                        this.dialogTitle = `Edit Status Change ${this._data.inward.jobNumber}`;
                        //this.statusChangeForm.patchValue(this.statusChange);
                    }
                    else {
                        this._alertMessage.error(res.errors.join('\n'));
                        this.onClose();
                    }
                });
        }
    }


    displayStatusFn(): (value: string) => string {
        return (value: string) => {
            return InwardStatusData[value];
        }
    }

    saveAndClose() {
        const statusChange = this.statusChangeForm.getRawValue();

        const isInwardReported = this.inward?.reportId > 0;

        if (!isInwardReported && statusChange.inwardStatus === InwardStatus.Outward) {
            const errorMessage = "Inward does not have a report created. You cannot make an outward status change before creating a report.";
            setTimeout(() => {
                this._alertMessage.error(errorMessage);
            }, 1000);
            return;
        }

        if (statusChange.inwardId > 0 && this.multipleInwards.length == 0) {
            this._inwardsService.ReportStatusChange(statusChange).subscribe((response) => {
                if (response.isSuccess) {
                    // Show a success message
                    this._alertMessage.success("Status Change added successfully");
                    // Close the dialog
                    this._matDialogRef.close(response);
                }
                else {
                    this._alertMessage.error(response.errors.join("\n"));
                }
            });
        }

        if (this.multipleInwards.length > 0) {
            statusChange.inwardIds = this.multipleInwards.map(a => a.id)
            this._inwardsService.multipleReportStatusChange(statusChange).subscribe((response) => {
                if (response.isSuccess) {
                    // Show a success message
                    this._alertMessage.success("Status Changes successfully");
                    // Close the dialog
                    this._matDialogRef.close(response);
                }
                else {
                    this._alertMessage.error(response.errors.join("\n"));
                }
            });
        }


    }


    // updateAndClose() {

    //   const statusChange = this.statusChangeForm.getRawValue();

    //   this._inwardsService.updateOutward(statusChange).subscribe((response) => {
    //     if (response.isSuccess) {
    //       // Show a success message
    //       this._alertMessage.success("Status Change updated successfully");
    //       // Close the dialog
    //       this._matDialogRef.close(response);
    //     }
    //     else {
    //       this._alertMessage.error(response.errors.join("\n"));
    //     }
    //   });
    // }
    onClose(): void {
        this._matDialogRef.close();
    }

    private _usersfilter(name: string): CommonDropDown[] {
        const filterValue = name.toString().toLowerCase();

        return this.users.filter(option => option.name.toLowerCase().includes(filterValue));
    }

    onUserSearch(value) {
        this.filterUsers = this._usersfilter(value);
    }

    getNextEnumValue(currentValue: InwardStatus): InwardStatus | undefined {
        const enumArray = Object.values(InwardStatus);

        const currentIndex = enumArray.indexOf(currentValue);

        if (currentIndex !== -1 && currentIndex < enumArray.length - 1) {
            return enumArray[currentIndex + 1] as InwardStatus;
        }

        return undefined;
    }

}
